var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"max-height":"10px","padding-top":"30px","padding-left":"30px","padding-bottom":"10px"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }